export const OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'b2b-overview',
};
export const OVERVIEW_PRODUCTS_ROUTE = {
    title: `Today's Latest Sold Products`,
    name: 'b2b-sold-products',
};
export const OVERVIEW_SALES_ROUTE = {
    title: `Today's Sales Amount`,
    name: 'b2b-sales-amount',
};
export const OVERVIEW_CUSTOMERS_ROUTE = {
    title: `Today's Latest Customers`,
    name: 'b2b-latest-customers',
};
export const PERFORMANCE_ROUTE = {
    title: 'Mini Appp Shop Performance',
    name: 'b2b-performance',
};
export const PERFORMANCE_POPULAR_PRODUCTS_ROUTE = {
    title: 'Most Viewed Products',
    name: 'b2b-popular-products',
};
export const PERFORMANCE_PROFITABLE_PRODUCTS_ROUTE = {
    title: 'Most Sold Products',
    name: 'b2b-profitable-products',
};
export const PRODUCTS_ROUTE = {
    title: 'Products',
    name: 'b2b-products',
};
export const PRODUCTS_NEW_ROUTE = {
    title: 'Create Product',
    name: 'b2b-product-new',
};
export const PRODUCTS_EDIT_ROUTE = {
    title: 'Edit Product',
    name: 'b2b-product-edit',
};
export const PRODUCTS_DETAILS_ROUTE = {
    title: 'Product Details',
    name: 'b2b-product-details',
};
export const CATEGORIES_ROUTE = {
    title: 'Categories',
    name: 'b2b-categories',
};
export const CATEGORIES_NEW_ROUTE = {
    title: 'Create Category',
    name: 'b2b-category-new',
};
export const CATEGORIES_EDIT_ROUTE = {
    title: 'Edit Category',
    name: 'b2b-category-edit',
};
export const CATEGORIES_DETAILS_ROUTE = {
    title: 'Category Details',
    name: 'b2b-category-details',
};
export const CART_SETTINGS_ROUTE = {
    title: 'Checkout Settings',
    name: 'b2b-cart-settings',
};
export const CART_PROMOS_ROUTE = {
    title: 'Cart Promos',
    name: 'b2b-cart-promos',
};
export const CART_PROMOS_NEW_ROUTE = {
    title: 'Create Cart Promo',
    name: 'b2b-cart-promos-new',
};
export const CART_PROMOS_EDIT_ROUTE = {
    title: 'Edit Cart Promo',
    name: 'b2b-cart-promos-edit',
};
export const DELIVERY_AREAS_ROUTE = {
    title: 'Delivery Areas',
    name: 'b2b-delivery-areas',
};
export const DELIVERY_AREAS_NEW_ROUTE = {
    title: 'Create Delivery Area',
    name: 'b2b-delivery-areas-new',
};
export const DELIVERY_AREAS_EDIT_ROUTE = {
    title: 'Edit Delivery Area',
    name: 'b2b-delivery-areas-edit',
};
export const SHIPPING_ROUTE = {
    title: 'Shipping',
    name: 'b2b-shipping',
};
export const SHIPPING_NEW_ROUTE = {
    title: 'Create Shipping',
    name: 'b2b-shipping-new',
};
export const SHIPPING_EDIT_ROUTE = {
    title: 'Edit Shipping',
    name: 'b2b-shipping-edit',
};
export const PAYMENT_ROUTE = {
    title: 'Payment',
    name: 'b2b-payment',
};
export const PROMOS_ROUTE = {
    title: 'Promo Codes',
    name: 'b2b-promo-codes',
};
export const PROMOS_NEW_ROUTE = {
    title: 'Create Promo Code',
    name: 'b2b-promo-codes-new',
};
export const PROMOS_EDIT_ROUTE = {
    title: 'Edit Promo Code',
    name: 'b2b-promo-codes-edit',
};
export const ADDONS_ROUTE = {
    title: 'Add-Ons',
    name: 'b2b-addons',
};
export const ADDONS_NEW_ROUTE = {
    title: 'Create Add-Ons',
    name: 'b2b-addons-new',
};
export const ADDONS_EDIT_ROUTE = {
    title: 'Edit Add-Ons',
    name: 'b2b-addons-edit',
};
export const APPLICATIONS_ROUTE = {
    title: 'Applications',
    name: 'b2b-applications',
};
export const ORDERS_ROUTE = {
    title: 'Order Tracker',
    name: 'b2b-orders-by-status',
};
export const ORDERS_HISTORY_ROUTE = {
    title: 'Order History',
    name: 'b2b-order-history',
};
export const CUSTOMER_SEGMENT_ROUTE = {
    title: 'Customer Segment',
    name: 'b2b-customer-segment',
};
export const BROADCAST_ROUTE = {
    title: 'Broadcast',
    name: 'b2b-broadcast',
};
